const OrderTotal = ({ data }) => {
    return (
        <div className="row">
            <div className="col-md-6">
                <div className="card text-white bg-info mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">${data.TIKTOK?.percent || "0%"} TIKTOK SHIP</h5>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card text-white bg-primary mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">${data.SELLER?.percent || "0%"} SELLER SHIP</h5>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card text-white bg-info mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">
                            {data.TIKTOK?.avg_delivery_days || "0"} days AVG. Delivery (TIKTOK)
                        </h5>
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card text-white bg-primary mb-3">
                    <div className="card-body px-4 text-white">
                        <h5 className="card-title text-white">
                            {data.SELLER?.avg_delivery_days || "0"} days AVG. Delivery (SELLER)
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderTotal;
